import { ICertificateData } from "@app/certificates/manage/manage";

export const getCertificateFullName = (cert: ICertificateData) => {

 const serial = `SN: ${cert.serialNo}`;
 let descr = serial;
 if (cert.alias) {
      descr = `${cert.alias} / ${serial}`;
    }
 return descr;
};
